import { render, staticRenderFns } from "./SocialMediaChallenge.vue?vue&type=template&id=66eea71e&scoped=true&"
import script from "./SocialMediaChallenge.vue?vue&type=script&lang=js&"
export * from "./SocialMediaChallenge.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaChallenge.vue?vue&type=style&index=0&id=66eea71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eea71e",
  null
  
)

export default component.exports